module.exports = __webpack_public_path__ + "static/lando_cover-49bc1e9ba54dd6b7fba7fca6f9a379f2.png";